import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StaticMsgModule } from '@lib/pipes';
import { ReceiptSearchSubHeaderComponent } from './receipt-search-sub-header.component';

@NgModule({
  declarations: [ReceiptSearchSubHeaderComponent],
  imports: [CommonModule, StaticMsgModule],
  exports: [ReceiptSearchSubHeaderComponent],
})
export class ReceiptSearchSubHeaderModule {}
